/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
import {handleErrorStatuses} from "../../../utils/internal-error-handler";
import {RESULT_TYPE_PEDIATRICS,
    NEOFAX_FORMULA_PICKLIST_ID,
    NEOFAX_PEDIATRICS_ERROR_TYPE,
    PEDIATRICS_FORMULA_PICKLIST_ID} from "../common/constants";

const NEOFAX_ERROR = "mdx_pwa.neofax.error";

export async function fetchAndHandleResponse(params, dispatch, rejectWithValue, processResponse) {
    try {
        const {fetcher, history, loginPage = {}} = params;
        const response = await fetcher();
        const status = response.status;

        if (status === 200) {
            if (response.redirected) {
                sessionStorage.setItem(NEOFAX_ERROR, true);
                window.location.href = response.url;
                throw new Error('Failed to fetch drug data');
            }
        } else {
            let mutable_props = {history};
            mutable_props.error_type = NEOFAX_PEDIATRICS_ERROR_TYPE;
            const getLoginState = () => ({login_page: loginPage});
            handleErrorStatuses(status, mutable_props, dispatch, getLoginState);
            return rejectWithValue({
                message: 'Failed to fetch data',
                status
            });
        }

        const responseBody = await response.json();
        processResponse(responseBody, dispatch, params)

        return responseBody;
    } catch (error) {
        return rejectWithValue(error?.response?.data);
    }
}

export const computeInitialPicklistId = (tabParam, hasNeonatalSubscription, hasPediatricSubscription) => {
    const isParamPediatric = tabParam === RESULT_TYPE_PEDIATRICS;
    // show Neotatal as long as they have a neonatal subscription and they did not explicitly request Pediatric
    const wantNeotatal = (!isParamPediatric && hasNeonatalSubscription) // did not explicitly request Pediatric and has Neonatal subscription
      || // OR
      (hasNeonatalSubscription && !hasPediatricSubscription); // has Neonatal subscription and no Pediatric subscription, ignoring the explicit request

    const wantPediatric = (isParamPediatric && hasPediatricSubscription) // explicitly requested Pediatric and has subscription
      ||  // OR
      (!hasNeonatalSubscription && hasPediatricSubscription); // has Pediatric subscription and no Neonatal subscription, ignoring the explicit request

    return wantNeotatal ? NEOFAX_FORMULA_PICKLIST_ID : (wantPediatric ? PEDIATRICS_FORMULA_PICKLIST_ID : null);
}
